// Shared public-site constants + helpers — single source of truth for all public pages.
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_e63e5c23-c73b-48e4-b5bd-c8da1ff8d651/artifacts/25pknzhh_ee436b9cf26fbe3a949749993a8a0799c33dc4d497d0bf4b65f923b400bf1fc0.jpeg";
export const FACEBOOK_URL = "https://www.facebook.com/share/14SYLdTSJVp/";
export const WHATSAPP_NUMBER = "447359139941";
const WHATSAPP_MESSAGE = "Hi Sandy and Mark, I found your website and I'm interested in your handyman services. ";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
export const SITE_ORIGIN = "https://sustainablehandymanservices.uk";

// Public contact fallbacks — the live values come from /api/public/business-info
// (admin Settings). These are the ONLY hardcoded copies; every public page must
// use bizInfo?.business_* || DEFAULT_* rather than embedding its own literal.
export const DEFAULT_PHONE = "07359 139941";
export const DEFAULT_EMAIL = "Sandy@sustainablehandymanservices.uk";
export const DEFAULT_ADDRESS = "Unit 7, Blaenant Industrial Estate, Blaenavon Rd, Brynmawr, NP23 4BX";

// Full image URL helper — handles local paths and legacy Google Drive URLs via proxy
export const getImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    const driveViewMatch = url.match(/drive\.google\.com\/file\/d\/([^/]+)\/view/);
    if (driveViewMatch) return `${window.location.origin}/api/drive-proxy/${driveViewMatch[1]}`;
    const driveUcMatch = url.match(/drive\.google\.com\/uc\?export=view&id=([^&]+)/);
    if (driveUcMatch) return `${window.location.origin}/api/drive-proxy/${driveUcMatch[1]}`;
    const driveUcMatch2 = url.match(/drive\.google\.com\/uc\?id=([^&]+)/);
    if (driveUcMatch2) return `${window.location.origin}/api/drive-proxy/${driveUcMatch2[1]}`;
    const lh3Match = url.match(/lh3\.googleusercontent\.com\/d\/([^=]+)/);
    if (lh3Match) return `${window.location.origin}/api/drive-proxy/${lh3Match[1]}`;
    return url;
  }
  return `${window.location.origin}${url}`;
};
